/**
 * Canonical story illustration style IDs — must match backend Story.storyStyle enum.
 */

export const STORY_STYLE_IDS = [
  "watercolor",
  "cartoon",
  "cinematic_animated",
  "pixar_3d",
  "storybook_classic",
  "manga_anime",
  "minimalist",
  "fantasy_magical",
  "crayon_childlike",
  "paper_cut_collage",
] as const;

export type StoryStyleId = (typeof STORY_STYLE_IDS)[number];

/** R2 object filenames under the public `style/` prefix (e.g. …/r2.dev/style/watercolor.png) */
export const STORY_STYLE_PREVIEW_FILES: Record<StoryStyleId, string> = {
  watercolor: "watercolor.png",
  cartoon: "cartoon.png",
  cinematic_animated: "Disney-Inspired.png",
  pixar_3d: "Pixar-Inspired 3D.png",
  storybook_classic: "Storybook Classic.png",
  // R2 object keys use double spaces in these names (must match bucket exactly)
  manga_anime: "Manga  Anime.png",
  minimalist: "Minimalist.png",
  fantasy_magical: "Fantasy  Magica.png",
  crayon_childlike: "Crayon  Childlike Drawing.png",
  paper_cut_collage: "Paper Cut  Collage.png",
};

/** Same default public bucket as wizard assets (FeaturesStrip, index.css). Override with REACT_APP_R2_PUBLIC_BASE_URL if needed. */
export const DEFAULT_R2_PUBLIC_ASSETS_BASE = "https://pub-dd11db53b680447d86c08d43682efe32.r2.dev";

export function storyStylePreviewUrl(styleId: StoryStyleId): string {
  const base = (process.env.REACT_APP_R2_PUBLIC_BASE_URL || DEFAULT_R2_PUBLIC_ASSETS_BASE).replace(/\/$/, "");
  const file = STORY_STYLE_PREVIEW_FILES[styleId];
  return `${base}/style/${encodeURIComponent(file)}`;
}

export function normalizeFrontendStoryStyleId(id: unknown): StoryStyleId {
  if (typeof id === "string" && STORY_STYLE_IDS.includes(id as StoryStyleId)) return id as StoryStyleId;
  return "watercolor";
}
